export const FacilityFields = [
	{
		type: "checkbox-set",
		name: "activities",
		options: "activities",
		form: "activities"
	},
	{
		type: "checkbox",
		name: "permanent",
		label: "Permanent care",
		form: "care-health-services"
	},
	{
		type: "checkbox-set",
		name: "agestage",
		options: "agestage",
		form: "care-health-services"
	},
	{
		type: "checkbox-set",
		name: "specialisedcare",
		options: "specialisedCare",
		form: "care-health-services"
	},
	{
		type: "radio",
		name: "securedementiarooms",
		options: "provideSecureDementiaCare",
		form: "care-health-services"
	},
	{
		type: "checkbox-set",
		name: "advancedcare",
		options: "advancedCare",
		form: "care-health-services"
	},
	{
		type: "checkbox",
		name: "respite",
		label: "Respite care",
		form: "care-health-services"
	},
	{
		type: "checkbox-set",
		name: "mentalhealth",
		options: "mentalhealth",
		form: "care-health-services"
	},
	{
		type: "checkbox-set",
		name: "therapycare",
		options: "therapyCare",
		form: "care-health-services"
	},
	{
		type: "radio",
		name: "category",
		options: "categories",
		form: "facility-type"
	},
	{
		type: "radio",
		name: "serviceLevel",
		options: "serviceLevel",
		form: "facility-type"
	},
	{
		type: "date",
		name: "accreditationdate",
		form: "facility-type"
	},
	{
		type: "checkbox",
		name: "extraservicestatus",
		label: "This facility has Extra Service Status",
		form: "facility-type"
	},
	{
		type: "checkbox",
		name: "showrad",
		label: "Show room RAD pricing",
		form: "facility-type"
	},
	{
		type: "checkbox",
		name: "fromRAD",
		label: "Only show the lowest RAD ('from' pricing)",
		form: "facility-type"
	},
	{
		type: "checkbox",
		name: "radnegotiable",
		label: "RADs are negotiable",
		form: "facility-type"
	},
	{
		type: "checkbox-set",
		name: "features",
		options: "amenities",
		form: "features-amenities"
	},
	{
		type: "text",
		label: "Street address",
		name: "addressline1",
		form: "location"
	},
	{
		type: "text",
		name: "addressline2",
		form: "location"
	},
	{
		type: "text",
		label: "Suburb",
		name: "suburb",
		form: "location"
	},
	{
		type: "text",
		label: "Postcode",
		name: "postcode",
		form: "location"
	},
	{
		type: "map",
		name: "latlon",
		form: "location"
	},
	{
		type: "checkbox",
		name: "culturespecific",
		label: "My facility is culturally-specific",
		form: "cultural-diversity"
	},
	{
		type: "checkbox",
		name: "culturecommunity",
		label: "My facility has a cultural community",
		form: "cultural-diversity"
	},
	{
		type: "checkbox",
		name: "lgbti",
		label: "My facility is LGBTI friendly",
		form: "cultural-diversity"
	},
	{
		type: "checkbox",
		name: "lgbtiaccredited",
		label: "My facility is 'Rainbow Tick' accredited",
		form: "cultural-diversity"
	},
	{
		type: "checkbox",
		name: "disabilities",
		label: "My facility can support people who have NDIS funding",
		form: "cultural-diversity"
	},
	{
		type: "checkbox",
		name: "ndisprovider",
		label: "My facility is an approved NDIS provider",
		form: "cultural-diversity"
	},
	{
		type: "org-select",
		label: "Select organisation",
		name: "organisationid",
		form: "organisation-select"
	},
	{
		type: "text",
		label: "Name",
		name: "title",
		form: "title-field"
	},
	{
		type: "text",
		label: "Previous name",
		name: "previoustitle",
		form: "title-field"
	},
	{
		type: "image",
		label: "Logo image",
		name: "image",
		form: "title-field"
	},
	{
		type: "text",
		label: "Phone number-general enquiries",
		name: "phone",
		form: "contact"
	},
	{
		type: "checkbox",
		name: "setAsContact",
		label: "Also show this person as the contact person",
		form: "contact"
	},
	{
		type: "text",
		label: "Website URL",
		name: "websiteurl",
		form: "contact"
	},
	{
		type: "org-user-select",
		label: "Clinical contact user",
		name: "clinicalcontactuserid",
		form: "contact"
	},
	{
		type: "org-user-select",
		label: "Clinical email user",
		name: "clinicalemailuserid",
		form: "contact"
	},
	{
		type: "wysiwiyg",
		name: "longdescription",
		label: "Detailed description",
		form: "description"
	},
	{
		type: "org-select",
		label: "Organisation",
		name: "organisationid",
		form: "listing-settings"
	},
	{
		type: "text",
		name: "slug",
		form: "listing-settings"
	},
	{
		type: "radio",
		label: "Appearance",
		name: "plan",
		options: "plans",
		form: "listing-settings"
	},
	{
		type: "checkbox",
		name: "onboardingreceived",
		label: "Onboarding form received from Provider",
		form: "listing-settings"
	},
	{
		type: "checkbox",
		name: "updatesoutstanding",
		label: "Updates outstanding",
		form: "listing-settings"
	},
	{
		type: "checkbox",
		name: "dailycare",
		label: "DailyCare",
		form: "listing-settings"
	},
	{
		type: "radio",
		name: "plan",
		options: "plans",
		form: "listing-type"
	},
	{
		type: "checkbox",
		name: "showrad",
		label: "Include RAD pricing in published vacancies",
		form: "listing-type"
	},
	{
		type: "image-gallery",
		name: "images",
		form: "photos"
	},
	{
		type: "textarea",
		name: "video",
		label: "YouTube/Vimeo embed code",
		form: "video"
	},
	{
		type: "radio",
		name: "hashomecare",
		label: "Has home care",
		form: "care-health-services",
	},
];
